module.exports = __webpack_public_path__ + "img/home-actions.124abf52.svg";